export default __webpack_public_path__ + "static/media/full1.f78c07bc.jpg";